import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface addPaymentVoucherFields {
    supplier_id?: number;
    supplier_name?: string;
    voucher_no?: string;
    date?: string;
    value?: number;
    paragraph?: string;
}

// Add payment voucher state
export interface addPaymentVoucherState {
    fields: addPaymentVoucherFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddPaymentVoucherState: addPaymentVoucherState = {
    fields: {
        date: (new Date()).toISOString().substr(0,10),
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Add payment voucher slice
export const addPaymentVoucherSlice = createSlice({
    name: 'add_payment_voucher',
    initialState: initialAddPaymentVoucherState,
    reducers: {
        init: state => initialAddPaymentVoucherState,
        set: ( state, {payload}: PayloadAction<addPaymentVoucherFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setAll: ( state, {payload}: PayloadAction<addPaymentVoucherFields> ) => {
            state.fields = payload
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})